// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__gc6WR","author":"Table_author__B4FCr","authorImage":"Table_authorImage__2BqHE","unreadRow":"Table_unreadRow__NwE8Q"};